import {
    Button, Checkbox, ListItemSecondaryAction, Icon, Paper, IconButton, Divider, InputBase, List, ListItem, ListItemIcon
    , ListItemText, div
} from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import SearchIcon from '@material-ui/icons/Search';
import CloseIcon from '@material-ui/icons/Close';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import Loading from '../../loading';
import Snackbar from '../../snackbar';
import AddCategory from '../../modalCategoryPost'
import { styles } from './styles';

function Transition(props) {
    return <Slide direction="down" {...props} />;
}

function desc(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function stableSort(array = [], cmp) {
    array = array || [];
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = cmp(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
}

function getSorting(order, orderBy) {
    return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}
class DialogComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: this.props.open || false,
            list_categories: [],
            order: 'asc',
            orderBy: 'name',
            selected: [],
            search: ''
        }
    }

    componentWillMount() {
        this.props.onRef(null);
    }

    snackbar = (mess, type) => {
        this.mSnackbar.handleClick(mess, type)
    }
    getListMultiLevel = async() => { 
        
        this.loading.startLoading()
        let check = await this.props.getListMultiLevel();
        this.loading.stopLoading()
        if(check && check.code) { 
            
        }
        else {
            this.snackbar(check.message || 'Something went wrong', 'error') 
        }  
    }
    getList = async() => { 
        
        this.loading.startLoading()
        let check = await this.props.getList({not_save: true});
        this.loading.stopLoading()
        if(check && check.code) { 
            this.setState({list_categories: check.data})
        }
        else {
            this.snackbar(check.message || 'Something went wrong', 'error') 
        }  
    }
    
    componentDidMount() {
        this.props.onRef(this)
    }
    handleOpen = () => {
        this.setState({ open: true });
        this.getListMultiLevel();
        this.getList()
    }
    handleClose = () => {
        // this.setState({ ...this.state, ...{ open: false } });
        this.setState({ open: false });
    }

    isSelected = id => {
        return this.state.selected.indexOf(id) !== -1
    };
    handleCheckbox = (event, id) => {
        const { selected } = this.state;

        let newSelected = [];
        
        let selectedIndex = selected.indexOf(id);
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }
        this.setState({ selected: newSelected });
    };
    action = () => {
        const { selected } = this.state;
        const { list_categories } = this.state;

        let categories = [];
        selected.forEach(id => {
            let find = list_categories.find(e => e.id === id);
            if(!find) {
                // list_categories.forEach(e => {
                //     let ele = e.subMenu.find(i => i.id === id)
                //     if(ele) {
                //         categories.push(ele)
                //     }
                // });
            }
            if(find) {
                categories.push(find)
            }
        })
        this.props.action(categories);
        this.handleClose()
    }

    handleSearch = async (e) => {
        let { t } = this.props
        let target = e.target;
        let value = e.target.value
        this.setState({search: value}, async function() {
            this.loading.startLoading();
            let check;
            if(value) {
                check = await this.props.getList({ search: value });
            }
            else {
                check = await this.props.getListMultiLevel({ search: value });
            }
            this.loading.stopLoading();

            if (check && check.code) {
                // this.mSnackbar.handleClick(t('category_post_no_result_found'))
            }
            else if (!check || !check.code) {
                this.mSnackbar.handleClick(check.message || 'Something went wrong', 'error')
            }
        })
    }
    renderMenuItem = (item, menuLevel) => {
        const { classes } = this.props;
        
        const isSelected = this.isSelected(item.id);
        let style = { cursor: 'pointer', paddingLeft: `${menuLevel * 8 * 2}px`, borderBottom: 'none', height: '2rem', marginBottom: 8 }
        return ([
            <ListItem onClick={event => this.handleCheckbox(event, item.id)} classes={{ container: classes.listItem }} style={style} key={`menu-${item.id}`} role={undefined} divider={true}>
                <ListItemIcon>
                    <Checkbox
                        edge="start"
                        checked={isSelected}
                        tabIndex={-1}
                        disableRipple
                        // style={{paddingLeft: 0}}
                        // onClick={event => this.handleCheckbox(event, item.id)}
                        inputProps={{ 'aria-labelledby': item.id }}
                    />
                </ListItemIcon>
                <ListItemText id={item.id} primary={item.name} />
            </ListItem>,
            item.subMenu && item.subMenu.length > 0 && item.subMenu.map((item, i) => { 
                return this.renderMenuItem(item, menuLevel + 1) 
            })
        ])
    }
    handleOpenCreate = () => {
        this.mCreateCategory && this.mCreateCategory.handleDialogOpen()
    }
    render() {
        const { classes, list_categories, theme, t } = this.props;
        const {order, orderBy, search} = this.state;
        return (
            <>
            <AddCategory onRef={category => (this.mCreateCategory = category)} />
            <div className={classes.wrapDialog}>
                {/* <AddCategory onRef={category => (this.mCreateCategory = category)} /> */}
                <Dialog
                    fullWidth={true}
                    maxWidth={'xs'}
                    open={this.state.open}
                    TransitionComponent={Transition}
                    keepMounted
                    onClose={this.handleDialogClose}
                    // style = {{zIndex: '3000 !important'}}
                    >
                    
                    <Loading onRef={id => (this.loading = id)} />
                    <Snackbar
                        color='white'
                        onRef={snackbar => (this.mSnackbar = snackbar)} />
                    {/* <DialogTitle>
                        {this.props.title}
                    </DialogTitle> */}
                    <DialogContent style={{minHeight: 300, paddingTop: 16}}>

                        <div className={classes.root}>
                            <div style={{width: '100%'}}>
                                <div style={{display: 'flex', alignItems: 'center', border: '1px solid #ccc'}}>
                                    <InputBase
                                        className={classes.input}
                                        value={search}
                                        onChange={this.handleSearch}
                                        placeholder={t("category_post_search") + '...'}
                                    />
                                    <IconButton onClick={this.handleSearch} className={classes.iconButton} aria-label="Search">
                                        <SearchIcon />
                                    </IconButton>
                                    <Divider className={classes.divider} />
                                    <IconButton onClick={this.handleOpenCreate} color="primary" className={classes.iconButton} aria-label="Directions">
                                        {/* <DirectionsIcon /> */}
                                        <Icon className={classes.icon}  >
                                            add_circle
                                            </Icon>
                                    </IconButton>
                                </div>
                                <div style={{marginTop: 16, padding: '8px 0px', border: '1px solid #ccc'}}>
                                    <List className={classes.rootList} dense={true}>
                                        
                                        {stableSort(list_categories, getSorting(order, orderBy))
                                            .map((row, index) => {
                                                return this.renderMenuItem(row, 1)
                                            })
                                        }
                                    </List>
                                </div>
                            </div>
                        </div>
                    </DialogContent>

                    <DialogActions>
                        <Button onClick={this.handleClose} color="primary">{'Cancel'}</Button>
                        <Button onClick={this.action} color="primary">{'OK'}</Button>
                    </DialogActions>
                </Dialog>
            </div>
            </>
        );
    }
}

DialogComponent.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
};

const mapState = state => ({
    list_categories: state.postCategory.list,
});

const mapDispatch = dispatch => ({
    getListMultiLevel: dispatch.postCategory.getListMultiLevel,
    getList: dispatch.postCategory.getList,
});

export default connect(mapState, mapDispatch)(translate('translations')(withStyles(styles, { withTheme: true })(DialogComponent)));